module.exports = __webpack_public_path__ + "img/air_compressor.9b6bf203.svg";